import axios from 'axios';
const endpoint = '/api/krainaabc/subprofile/activity/visit?device=www';

export function registerVisit(object_id, subProfile_id) {
    let data = {};
    data['object_id'] = object_id;      
    data['subProfile_id'] = subProfile_id;

    axios
        .post(endpoint, data)
        .then(() => {
        })
        .catch((error) => {
            console.log(error);
        });
}